import { Location } from '@angular/common';
import { Component, inject, Input } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  @Input() hideBack = false;
  private readonly location = inject(Location);
  constructor() {}
  goBack() {
    this.location.back(); // <-- go back to previous location on cancel
  }
}
